const CompanyInfo = {
  nomeEmpresarial: 'Drogaria Araújo SA',
  nomeFantasia: 'Drogaria Araújo',
}

export default { CompanyInfo }
